import type { AboutCopy } from '../types/about';

export const aboutDe: AboutCopy = {
  seo: {
    title: 'Über uns',
    description:
      'SafestMenu wird von transfactor.dev entwickelt und betrieben, einem erfahrenen Software-Team in Bukarest, Rumänien - zertifiziert nach ISO 9001 und ISO/IEC 27001.',
  },
  hero: {
    eyebrow: 'Über uns',
    heading: 'Gemacht von Menschen, die beruflich Software entwickeln - und oft essen gehen.',
  },
  story: {
    intro:
      'SafestMenu entstand aus einer einfachen Beobachtung: Papierspeisekarten sind teuer im Nachdruck, praktisch unmöglich aktuell zu halten, gehen durch Hunderte Hände und landen stapelweise im Müll. Jedes Restaurant, mit dem wir gesprochen haben, hatte dasselbe Problem - und keine Zeit für eine komplizierte Lösung.',
    easyIntro:
      'Also haben wir die Speisekarte gebaut, die wir uns für unser eigenes Restaurant wünschen würden: eine, die Sie in Minuten einrichten, vom Handy aus aktualisieren und nie wieder drucken müssen. ',
    easyHighlight: 'Einfach zu bedienen',
    easyOutro: ' war kein Punkt auf einer Liste - es war der ganze Sinn der Sache.',
    imageAlt: 'Eine SafestMenu-QR-Code-Tischkarte auf einem Cafétisch neben einem Espresso',
  },
  team: {
    heading: 'Das Team dahinter',
    linkIntro: 'SafestMenu wird entwickelt und betrieben von ',
    linkText: 'transfactor.dev',
    linkOutro:
      ', einem erfahrenen Software-Team mit Sitz in Bukarest, Rumänien. transfactor.dev entwirft, baut und veröffentlicht Web-Produkte, KI-Systeme und interne Tools - über zwanzig veröffentlichte Produkte und achtzehn Jahre gemeinsame Erfahrung, zertifiziert nach ISO 9001 und ISO/IEC 27001.',
    reliability:
      'Das ist für Sie ganz konkret wichtig: SafestMenu ist kein Nebenprojekt, das nächstes Jahr wieder verschwindet. Es wird jede Woche vom selben Team gepflegt, abgesichert und weiterentwickelt.',
  },
  beliefs: {
    heading: 'Woran wir glauben',
    items: [
      'Software für Restaurants sollte einfacher sein als ein Restaurant zu führen.',
      'Gäste haben ehrliche Speisekarten verdient: klare Preise, echte Fotos, markierte Allergene.',
      'Weniger Papier im Müll ist gut für alle - Ihr Budget eingeschlossen.',
    ],
  },
  cta: {
    label: 'SafestMenu kostenlos testen',
  },
};
